export const yellow = '#FFC425'
export const red = '#8C0B05'
export const blue = '#8AB7E9'
export const button = 'black'
export const newsEvents = 'black'
